import { render, staticRenderFns } from "./user-leave.vue?vue&type=template&id=04a7e58a&scoped=true&"
import script from "./user-leave.vue?vue&type=script&lang=ts&"
export * from "./user-leave.vue?vue&type=script&lang=ts&"
import style0 from "./user-leave.vue?vue&type=style&index=0&id=04a7e58a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a7e58a",
  null
  
)

export default component.exports